const thirdProjectBkgd = require("url:../../assets/images/third-project-card.png");

customElements.define(
	"third-project-page",
	class initProjectPage extends HTMLElement {
		connectedCallback() {
			this.render();
			this.addListeners();
		}

		render() {
			this.innerHTML = `
            <div class="container">
                <header-comp></header-comp>
				<div class="project-card">
                <project-card src="${thirdProjectBkgd}" title="MASCHWITZ" address="Atahualpa Yupanqui 1921, Ing.Maschwitz, Escobar." tags="Proyecto, Dirección, Renders, Arquitectura, Construcción, Desarrollo, Instalaciones, Iluminación">
					Proyecto de vivienda multifamiliar construida en Sistema de construcción en seco, Steel frame. Ubicado en Escobar, cerca del centro de Ing. Maschwitz.
				</project-card>
				</div>
            </div>
        	`;

			const style = document.createElement("style");
			style.textContent = `

            .container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
				user-select: none;
            }

			.loader-container {
                width: 100%;
				height: 100vh;
				display: flex;
				justify-content: center;
				align-items: center;
            }

			.project-card {
                width: 100%;
                height: 100vh;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
            }
        `;

			this.appendChild(style);
		}

		addListeners() {
			const bodyEl = document.querySelector("body");
			bodyEl.style.overflow = "hidden";
		}
	}
);
